import SHWFTrack from './src/list.vue';
/* istanbul ignore next */
SHWFTrack.install = function(Vue) {
  Vue.component('sh-wf-track', SHWFTrack);
};
export default SHWFTrack;


// WEBPACK FOOTER //
// ./src/components/base/view/wf/exec/cmps/track/list/index.js